import React, { useEffect, useState } from "react";
import "react-pro-sidebar/dist/css/styles.css";
import SearchBox from "./parts/SearchBox";
import AdvertSection from "./parts/AdvertSection";
import LayoutV1 from "markup/Layout/LayoutV1";
import CitySection from "./parts/CitySection";
import { Helmet } from "react-helmet";
import CategoryList from "../Category/CategoryList/CategoryList";
import Market from "../Market/Market";
import { useLocation } from "react-router-dom";
import RoleSelectModal from "markup/Element/RoleSelectModal";
import HeroConvergence from "./parts/HeroConvergence";
import StatsBand from "./parts/StatsBand";
import CategoryShowcase from "./parts/CategoryShowcase";
import PopularAdverts from "./parts/PopularAdverts";
import AutoScrollShowcase from "./parts/AutoScrollShowcase";
import PopularSearches from "./parts/PopularSearches";
import { ReklamLeaderboard, AlagozAdRail } from "./parts/HomeAds";

// Storage key — bump suffix when the welcome modal copy changes so users
// who already dismissed an older version see the new one.
const WELCOME_DISMISSED_KEY = "alicilar:roleSelectWelcome:v1";

// In-memory guard, shared across every Homepage mount in this page load.
// sessionStorage writes silently fail on iOS Safari in-app browsers,
// Private Browsing, and with cross-site tracking prevention — when that
// happens the storage flag never sticks and the welcome modal re-fires on
// every remount/navigation back to "/", popping up endlessly on mobile.
// This flag does not depend on storage succeeding, so the modal shows at
// most once per page load regardless.
let welcomeShownThisLoad = false;

function Homepage(props) {
  // Auto-show the role-select modal once per session on the homepage,
  // unless the user has already dismissed it. Slight delay so the page
  // can paint first and the entrance animation feels intentional rather
  // than a hard interrupt.
  const [welcomeOpen, setWelcomeOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // /ilan-ver mounts Homepage AND its own forced modal — don't double up.
    if (location.pathname !== "/") return undefined;
    if (welcomeShownThisLoad) return undefined;
    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(WELCOME_DISMISSED_KEY) === "1";
    } catch (e) {
      // Private mode or storage disabled — the in-memory guard still caps it.
    }
    if (dismissed) return undefined;
    const t = setTimeout(() => {
      welcomeShownThisLoad = true;
      setWelcomeOpen(true);
    }, 900);
    return () => clearTimeout(t);
  }, [location.pathname]);

  const closeWelcome = () => {
    setWelcomeOpen(false);
    try {
      sessionStorage.setItem(WELCOME_DISMISSED_KEY, "1");
    } catch (e) {
      // Best effort — if storage fails the modal will reappear on next mount.
    }
  };

  return (
    <LayoutV1>
      <Helmet>
        <title>Alıcılar</title>
        <meta
          name="description"
          content="Almak istediğin ne varsa ilan ver satıcısı seni bulsun !"
        />
      </Helmet>
      {/*TODO:Helmet components will be inside another components.*/}
      <div className="page-content">
        <ReklamLeaderboard />

        <div className="home-shell">
          <div className="home-shell-main">
            <div className="container">
              <div className="row mt-3 mb-3">
                <div className="col-xs-12 col-lg-3 mb-3">
                  <CategoryList />
                </div>
                <div className="col-xs-12 col-lg-9 search-box-container">
                  <SearchBox />
                  <HeroConvergence />
                </div>
              </div>
            </div>

            <StatsBand />

            <CategoryShowcase />

            <PopularAdverts />

            <AutoScrollShowcase />

            <PopularSearches />

            <AdvertSection />

            <CitySection />
            <Market />
          </div>

          <div className="home-shell-rail d-none d-lg-block">
            <div className="home-shell-rail-sticky">
              <AlagozAdRail />
            </div>
          </div>
        </div>
      </div>
      <RoleSelectModal open={welcomeOpen} onClose={closeWelcome} />
    </LayoutV1>
  );
}

export default Homepage;
